var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cd-section",attrs:{"id":"contact-us"}},[_c('Contact1'),_c('Contact2'),_c('Contact3'),_c('Contact4')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }